import React from "react";
import { css } from "styled-components";
import { Box } from "rebass";
import d from "dayjs";

const getCurrentHour = () => d().get("hour");
const closest = (hours: number[], currentHour: number) =>
  hours.reduce(function(prev, curr) {
    return Math.abs(curr - currentHour) < Math.abs(prev - currentHour)
      ? curr
      : prev;
  });

export const ColorOverlay = (props: {
  colors: string[];
  timeSchedule: Record<number, string>;
}) => {
  let colors = props.colors;
  if (props.timeSchedule) {
    const bgHourIndex = closest(
      Object.keys(props.timeSchedule).map(Number),
      getCurrentHour()
    );
    colors = [props.timeSchedule[bgHourIndex]];
  }

  return (
    <Box
      bg={colors}
      css={css`
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        content: "";
        z-index: 0;
      `}
    />
  );
};
